import constant from "../../util/constant";
import {
  ADMIN_EVENT_TYPE_API_REQUEST,
  ADMIN_EVENT_TYPE_API_END,
  ADD_ADMIN_EVENT_TYPE_SUCCESS,
  ADD_ADMIN_EVENT_TYPE_FAILURE,
  GET_ADMIN_EVENT_TYPES_SUCCESS,
  GET_ADMIN_EVENT_TYPES_FAILURE,
  GET_ADMIN_EVENT_TYPE_DETAIL_SUCCESS,
  UPDATE_ADMIN_EVENT_TYPE_SUCCESS,
  UPDATE_ADMIN_EVENT_TYPE_FAILURE,
  GET_ADMIN_EVENT_TYPE_DETAIL_FAILURE,
  ENABLE_DISABLE_EVENT_TYPE_SUCCESS,
  ENABLE_DISABLE_EVENT_TYPE_FAILURE
} from "../actionTypes";

const { API_STATUS } = constant;

const DEFAULT_STATE = {
  loading: false,
  message: "",
  status: "",
  apiType: "",
  adminEventTypes: { eventTypes: [], meta: "" },
  adminEventTypeDetail: {},
};

const adminEventType = ( state = DEFAULT_STATE, action = "" ) => {
  switch ( action.type ) {
    case ADMIN_EVENT_TYPE_API_REQUEST:
      return {
        ...state,
        status: API_STATUS.START,
        apiType: action.payload,
      };
    case ADMIN_EVENT_TYPE_API_END:
      return {
        ...state,
        status: API_STATUS.END,
        apiType: "",
      };
    case ADD_ADMIN_EVENT_TYPE_SUCCESS:
    case UPDATE_ADMIN_EVENT_TYPE_SUCCESS:
      return {
        ...state,
        status: API_STATUS.SUCCESS,
      };
    case ADD_ADMIN_EVENT_TYPE_FAILURE:
    case GET_ADMIN_EVENT_TYPE_DETAIL_FAILURE:
    case UPDATE_ADMIN_EVENT_TYPE_FAILURE:
    case ENABLE_DISABLE_EVENT_TYPE_FAILURE:
      return {
        ...state,
        status: API_STATUS.FAILURE,
      };
    case GET_ADMIN_EVENT_TYPES_FAILURE:
      return {
        ...state,
        status: API_STATUS.FAILURE,
        partnerEventTypes: { eventTypes: [], meta: "" },
      };
    case GET_ADMIN_EVENT_TYPES_SUCCESS:
      return {
        ...state,
        adminEventTypes: {
          eventTypes:
          action.payload.meta.page === 1
            ? action.payload.dataList
            : [ ...state.adminEventTypes.eventTypes, ...action.payload.dataList ],
          meta: action.payload.meta,
        },
        status: API_STATUS.SUCCESS,
      };
    case GET_ADMIN_EVENT_TYPE_DETAIL_SUCCESS:
      return {
        ...state,
        status: API_STATUS.SUCCESS,
        adminEventTypeDetail: action.payload,
      };
    case ENABLE_DISABLE_EVENT_TYPE_SUCCESS:
      return {
        ...state,
        status: API_STATUS.SUCCESS,
        message: action.payload,
        adminEventTypeDetail: {
          ...state.adminEventTypeDetail,
          isActive: !state.adminEventTypeDetail.isActive,
        },
      };
    default:
      return state;
  }
};

export default adminEventType;
